export const ScrollMixin = {
  data: () => ({
    animes: [
      // { 
      //   targets: [
      //     { name: '.model_viewer_layer .page_1 .title.main', status: 'opened' },
      //     { name: '.model_viewer_layer .page_1 .title.sub', status: 'opened' },
      //     { name: '.model_viewer_layer .page_1 .description.main', status: 'opened' },

      //     { name: '.model_viewer_layer .page_2 .title.main', status: 'closed' },
      //     { name: '.model_viewer_layer .page_2 .description.main', status: 'closed' },
      //     { name: '.model_viewer_layer .page_2 .contents .video_player_layer', status: 'closed' },
      //     { name: '.model_viewer_layer .page_2 .contents .description', status: 'closed' },
      //   ], 
      //   in: {
      //     translateX: [100, 0],
      //     opacity: [0, 1],
      //     easing: "easeOutExpo",
      //     duration: 2500
      //   },
      //   out: {
      //     translateX: -300,
      //     opacity: 0,
      //     easing: "easeOutExpo",
      //     duration: 2500
      //   }
      // },
    ],
    mounting: false
  }),
  mounted() {
    document.addEventListener('scroll', this.scroll, true)

    this.mounting = true
    setTimeout(() => { this.mounting = false }, 2000)
  },
  destroyed() {
    document.removeEventListener('scroll', this.scroll, true)
  },
  methods: {
    openOverContents(start=0, delay=0) {
      let delay__ = delay
      let h = window.outerHeight
      let started = false

      this.animes.forEach((anime, i) => {
        anime.targets.forEach((target, j) => {
          if(!target.name.includes('page_1') || target.status == 'opened') return

          let el = document.querySelector(target.name)
          let box = el.getBoundingClientRect()

          if(box.y > 0 && box.y < h - box.height) {
            setTimeout(() => {
              this.$anime({
                targets: target.items || target.name,
                ...anime.in
              })
              target.status = 'opened'
            }, !started ? start : start + delay)

            delay += delay__
            started = true
          }
        })
      })
    },
    scroll() {
      if(this.mounting) {
        window.scrollTo(0, 0)
        return
      }

      let h = window.outerHeight

      this.animes.forEach(anime => {
        anime.targets.forEach((target, i) => {
          let el = document.querySelector(target.name)
          let box = el.getBoundingClientRect()

          if(target.status == 'closed' && box.y > 0 && box.y < h - box.height) {
            this.$anime({
              targets: target.items || target.name,
              ...anime.in
            })
            target.status = 'opened'

          } else if(target.status == 'opened' && (box.y < 0 || box.y > h - box.height)) {
            this.$anime({
              targets: target.items || target.name,
              ...anime.out
            })
            target.status = 'closed'
          }
        })
      })
    },
    setScrollAnime(animes) {
      this.animes = animes
      this.animes.forEach(anime => {
        anime.targets.forEach((target, i) => {
          if(target.status == 'opened') return
          
          let els = document.querySelectorAll(target.items || target.name)
          els.forEach(el => {
            el.style.opacity = 0
          })
        })
      })
    }
  }
}